import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKodem = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0.142578 1.85686C0.142578 0.910089 0.91009 0.142578 1.85686 0.142578H12.1426C13.0894 0.142578 13.8569 0.91009 13.8569 1.85686V12.1426C13.8569 13.0894 13.0894 13.8569 12.1426 13.8569H1.85686C0.910089 13.8569 0.142578 13.0894 0.142578 12.1426V1.85686Z",
			fill: "url(#paint0_linear_13864_29054)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7716 2.93652H8.60849L6.08203 6.89339L8.60849 10.8502H10.7716L8.2438 6.89339L10.7716 2.93652Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.36705 2.9458H3.44336V10.8503H5.36705V2.9458Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_13864_29054",
			x1: 1.79337,
			y1: 3.57115,
			x2: 12.0791,
			y2: 9.66639,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .100856,
				stopColor: "#FF6868"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FEB45E"
			})]
		}) })
	]
});
const ForwardRef = forwardRef(SvgKodem);
export { ForwardRef as ReactComponent };
